import { render, staticRenderFns } from "./MenuRender.vue?vue&type=template&id=4abcd9b9&"
import script from "./MenuRender.vue?vue&type=script&lang=js&"
export * from "./MenuRender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports